export function shouldRenderNavbar(
  authenticated: boolean,
  privileged: boolean,
  pathname: string,
): boolean {
  if (!authenticated || privileged) return true
  return pathname === '/settings' || pathname.startsWith('/settings/')
}
